import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { PLATFORM_THEME_COLORS, Typography } from '@thinknet-gmbh/platform-common-ui';

import {
  InfoBlock,
  InfoElement,
  InfoWrapper,
} from 'src/pages/employee/sub-pages/employee-details-limited-view/employee-details-limited-view.styles';
import { formatByMask } from 'src/common/helpers/common.helpers';

const LimitedPersonalInfo = ({ personalInfo }: { personalInfo: any }) => {
  const { t } = useTranslation(['common', 'employee', 'settings']);

  return (
    <InfoWrapper>
      <InfoBlock>
        <InfoElement>
          <Typography weight="bold">{`${t('common:labels.firstName')}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {personalInfo?.profile?.firstName}
          </Typography>
        </InfoElement>
        <InfoElement>
          <Typography weight="bold">{`${t('common:labels.lastName')}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {personalInfo?.profile?.lastName}
          </Typography>
        </InfoElement>
        <InfoElement>
          <Typography weight="bold">{`${t(
            'employee:employeePersonalInfo.labels.gender'
          )}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {t(`employee:employeePersonalInfo.labels.${personalInfo?.profile?.gender?.toLowerCase()}`)}
          </Typography>
        </InfoElement>
        <InfoElement>
          <Typography weight="bold">{`${t('common:labels.status')}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {t(
              `employee:employeePersonalInfo.labels.statuses.${personalInfo?.employeePersonalInfo?.status?.toLowerCase()}`
            )}
          </Typography>
        </InfoElement>
        <InfoElement>
          <Typography weight="bold">{`${t('employee:labels.employeeNumber')}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {personalInfo?.employeePersonalInfo?.employeeNumber}
          </Typography>
        </InfoElement>
      </InfoBlock>
      <InfoBlock>
        <InfoElement>
          <Typography weight="bold">{`${t(
            'settings:company.labels.companyPhoneNumber'
          )}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {formatByMask(
              personalInfo?.activeWorkingCondition?.company?.number,
              '+## ### ### #######'
            )}
          </Typography>
        </InfoElement>
        <InfoElement>
          <Typography weight="bold">{`${t('common:labels.email')}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {personalInfo?.profile?.personalEmail}
          </Typography>
        </InfoElement>
        <InfoElement>
          <Typography weight="bold">{`${t('employee:labels.birthday')}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {moment(personalInfo?.profile?.birthday).format('DD.MM.YYYY')}
          </Typography>
        </InfoElement>
        <InfoElement>
          <Typography weight="bold">Linkedin:</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {personalInfo?.profile?.socials?.linkedIn}
          </Typography>
        </InfoElement>
        <InfoElement>
          <Typography weight="bold">{`${t('employee:labels.nationality')}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {personalInfo?.profile?.nationality
              ? t(`common:country.${personalInfo?.profile?.nationality}`)
              : '-'}
          </Typography>
        </InfoElement>
      </InfoBlock>
    </InfoWrapper>
  );
};

export default LimitedPersonalInfo;
